<template>
  <div
    class="col-xs-12"
    style="text-align: center"
  >
    <i
      class="fa fa-spinner fa-spin fa-fw fa-2x"
      style="margin-top: 20px;"
    />
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<style>

</style>
